export default "__VITE_PUBLIC_ASSET__c0901cea__"